/**
 * Erros de obrigatoriedade/formato só após tentativa de envio ou campo tocado
 * (SPEC Step 1 — validação).
 */
export type CapitalGlobalStep1FieldApiLike = {
  state: { meta: { isTouched: boolean } };
};

export function capitalGlobalStep1ShouldShowFieldErrors(
  isViewMode: boolean,
  submitAttempted: boolean,
  _fieldApi: CapitalGlobalStep1FieldApiLike
): boolean {
  if (isViewMode) return false;
  return submitAttempted;
}
